import { gql } from "@apollo/client";

export const UPDATE_USER_BRAND = gql`
  mutation UpdateUserBrand(
    $userId: Int!
    $brandId: Int!
    $roleId: Int!
    $isActive: Boolean!
    $customPermissions: [Int!]
  ) {
    updateUserBrand(
      params: {
        userId: $userId
        brandId: $brandId
        roleId: $roleId
        isActive: $isActive
        customPermissions: $customPermissions
      }
    ) {
      brandId
      brandName
      brandLogoUrl
      organizationId
      organizationName
      brandUserMappingId
      isAccessActive
      roles {
        roleId
        roleName
        roleKey
      }
      features {
        featureId
        featureName
        featureKey
        isMainMenu
        permissions {
          permissionId
          permissionName
          permissionKey
          isInherited
          isCustom
          isAssigned
        }
      }
    }
  }
`;
